import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { RoutePath } from '@helpcenter/constants';
import { useIntl } from 'react-intl-next';
import { getHelpCenterTopBarTextColor } from 'state/selectors/help-center';
import { LinkIconButton } from '@atlaskit/button/new';
import TrayIcon from '@atlaskit/icon/core/inbox';

import { useLinkPush } from '../../controllers/use-link-push';

import messages from './messages';

interface ConnectedProps {
    primaryColor: string;
}

const selector = createSelector(getHelpCenterTopBarTextColor, (primaryColor) => ({
    primaryColor,
}));

const CsmRequestsHeaderLinkDumb = ({ primaryColor }: ConnectedProps) => {
    const { formatMessage } = useIntl();

    const { push, baseUrl } = useLinkPush();
    const href = baseUrl + RoutePath.CSM_REQUESTS_LIST_PATH;

    return (
        <LinkIconButton
            shape="circle"
            href={href}
            icon={(iconProps) => (
                <span style={{ color: primaryColor }}>
                    <TrayIcon {...iconProps} />
                </span>
            )}
            label={formatMessage(messages.requests)}
            onClick={(event) => {
                push(RoutePath.CSM_REQUESTS_LIST_PATH, event);
            }}
        />
    );
};

export const CsmRequestsHeaderLink = connect(selector, {})(CsmRequestsHeaderLinkDumb);
